import { useNavigate } from 'react-router-dom';
import { t } from '../../../i18n/uiText';
import BfSheet from './BfSheet';
import {
  BfIconSearch,
  BfIconChat,
  BfIconClock,
  BfIconBookmark,
  BfIconSettings,
} from './BfIcons';

/**
 * BfMenuSheet — Settings-style меню тремя группами.
 * Discover · Library · Account.
 * Никаких chevron-стрелочек: Apple Books их не использует.
 */
export default function BfMenuSheet({
  onShowHistory,
  onShowBookmarks,
  onOpenSearch,
  onOpenChat,
  onGoSettings,
  onClose,
  showSearchAndChat = true,
}) {
  const navigate = useNavigate();

  const handleGoSettings = () => {
    if (onGoSettings) onGoSettings();
    else navigate('/settings');
  };

  return (
    <BfSheet
      title={t('menu')}
      onClose={onClose}
      ariaLabel={t('menu')}
      sheetClassName="bf-sheet--compact"
    >
      <div className="bf-menu">
        {showSearchAndChat && (onOpenSearch || onOpenChat) && (
          <div className="bf-menu-group">
            {onOpenSearch && (
              <button type="button" className="bf-menu-item" onClick={onOpenSearch}>
                <span className="bf-menu-item__icon">
                  <BfIconSearch />
                </span>
                <span className="bf-menu-item__label">{t('search')}</span>
              </button>
            )}
            {onOpenChat && (
              <button type="button" className="bf-menu-item" onClick={onOpenChat}>
                <span className="bf-menu-item__icon">
                  <BfIconChat />
                </span>
                <span className="bf-menu-item__label">{t('chatActionLabel')}</span>
              </button>
            )}
          </div>
        )}

        <div className="bf-menu-group">
          {onShowHistory && (
            <button type="button" className="bf-menu-item" onClick={onShowHistory}>
              <span className="bf-menu-item__icon">
                <BfIconClock />
              </span>
              <span className="bf-menu-item__label">{t('history')}</span>
            </button>
          )}
          {onShowBookmarks && (
            <button type="button" className="bf-menu-item" onClick={onShowBookmarks}>
              <span className="bf-menu-item__icon">
                <BfIconBookmark />
              </span>
              <span className="bf-menu-item__label">{t('savedTitle')}</span>
            </button>
          )}
        </div>

        <div className="bf-menu-group">
          <button type="button" className="bf-menu-item" onClick={handleGoSettings}>
            <span className="bf-menu-item__icon">
              <BfIconSettings />
            </span>
            <span className="bf-menu-item__label">{t('settings')}</span>
          </button>
        </div>
      </div>
    </BfSheet>
  );
}
